// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getHeader } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWidgetsByPageId } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";

export const getLogoImage = (state: ApplicationState) => {
    const logoImage = getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Basic/Logo";
    })?.fields.logoImage;
    return logoImage;
};

export const xIsAuthenticated = (state: ApplicationState): boolean => {
    const session = getSession(state);
    return session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
};
